export enum PageView {
  individualInsuranceSummaryView = 'Individual Insurance Summary View',
  individualInsuranceDetailView = 'Individual Insurance Detail View',
  groupInsuranceSummaryView = 'Group Insurance Summary View',
  groupInsuranceDetailView = 'Group Insurance Detail View',
  lifeInsuranceSummaryView = 'Life Insurance Summary View',
  lifeInsuranceDetailView = 'Life Insurance Detail View',
  privateInsuranceSummaryView = 'Private Insurance Summary View',
  privateInsuranceDetailView = 'Private Insurance Detail View',
  myDataView = 'My Data View',
  electronicSignatureView = 'Electronic Signature View',
  changePasswordView = 'Change Password View',
  payMyProductsView = 'Pay My Products View',
  profitabilityReportView = 'Profitability Report View',
  iiMyProductSummaryView = 'Individual Insurance - My Product Summary View',
  iiMyProductBenefitsClaimsView = 'Individual Insurance - My Product Benefits Claims View',
  iiMyProductEndorsementsView = 'Individual Insurance - My Product Endorsements View',
  iiMyProductPaymentsView = 'Individual Insurance - Individual Insurance - My Product Payments View',
  iiMyProductPaymentHistoryView = 'Individual Insurance - My Product Payment History View',
  iiManagingSavingsOnlineCartolaView = 'Individual Insurance - Managing Savings Online Cartola View',
  iiManagingSavingsTransfersView = 'Individual Insurance - Managing Savings Transfers View',
  iiManagingSavingsCostEffectivenessView = 'Individual Insurance - Managing Savings Cost Effectiveness View',
  iiManagingSavingsQuotaValuesView = 'Individual Insurance - Managing Savings Quota Values View',
  iiManagingSavingsRescueView = 'Individual Insurance - Managing Savings Rescue View',
  piSummaryView = 'Private Insurance - Summary View',
  piLiquidationView = 'Private Insurance - Liquidation View',
  piLegalGuardianshipView = 'Private Insurance - Legal Guardianship View',
  piRescueView = 'Private Insurance - Rescue View',
  liSummaryView = 'Life Insurance - Summary View',
  liLiquidationView = 'Life Insurance - Liquidation View',
  liLegalGuardianshipView = 'Life Insurance - Legal Guardianship View',
  liPensionCreditsView = 'Life Insurance - Pension Credits View',
  liFamilyResponsabilitiesView = 'Life Insurance - Family Responsabilities View',
  liCompensationBoxView = 'Life Insurance - Compensation Box View',
  liCertificatesView = 'Life Insurance - Certificates View',
  liRescueView = 'Life Insurance - Rescue View',
  giSummaryView = 'Group Insurance - Summary View',
  giDetailPlanView = 'Group Insurance - Detail Plan View',
  giFormsView = 'Group Insurance - Forms View',
  giRefundsView = 'Group Insurance - Refunds View',
}

export const getValuePageView: { [key in PageView]: string } = {
  [PageView.individualInsuranceSummaryView]: 'Seguro Individual Resumen',
  [PageView.individualInsuranceDetailView]: 'Seguro Individual Detalle',
  [PageView.groupInsuranceSummaryView]: 'Seguro Colectivo Resumen',
  [PageView.groupInsuranceDetailView]: 'Seguro Colectivo Detalle',
  [PageView.lifeInsuranceSummaryView]: 'Rentas Vitalicias Resumen',
  [PageView.lifeInsuranceDetailView]: 'Rentas Vitalicias Detalle',
  [PageView.privateInsuranceSummaryView]: 'Rentas Privadas Resumen',
  [PageView.privateInsuranceDetailView]: 'Rentas Privadas Detalle',
  [PageView.myDataView]: 'Mis Datos',
  [PageView.electronicSignatureView]: 'Firma Electrónica',
  [PageView.changePasswordView]: 'Cambiar Contraseña',
  [PageView.payMyProductsView]: 'Pagar Mis Productos',
  [PageView.profitabilityReportView]: 'Informe Rentabilidad',
  [PageView.iiMyProductSummaryView]: 'Seguro Individual - Mi Producto - Resumen',
  [PageView.iiMyProductBenefitsClaimsView]: 'Seguro Individual - Mi Producto - Beneficios y Siniestros',
  [PageView.iiMyProductEndorsementsView]: 'Seguro Individual - Mi Producto - Endosos y Solicitudes',
  [PageView.iiMyProductPaymentsView]: 'Seguro Individual - Mi Producto - Pagos y Aportes',
  [PageView.iiMyProductPaymentHistoryView]: 'Seguro Individual - Mi Producto - Historial De Pagos y Aportes',
  [PageView.iiManagingSavingsOnlineCartolaView]: 'Seguro Individual - Administración De Mis Ahorros - Cartola En Línea',
  [PageView.iiManagingSavingsTransfersView]: 'Seguro Individual - Administración De Mis Ahorros - Traslados',
  [PageView.iiManagingSavingsCostEffectivenessView]: 'Seguro Individual - Administración De Mis Ahorros - Rentabilidad',
  [PageView.iiManagingSavingsQuotaValuesView]: 'Seguro Individual - Administración De Mis Ahorros - Valores Cuota',
  [PageView.iiManagingSavingsRescueView]: 'Seguro Individual - Administración De Mis Ahorros - Rescates',
  [PageView.piSummaryView]: 'Seguro Privado - Resumen',
  [PageView.piLiquidationView]: 'Seguro Privado - Liquidaciones',
  [PageView.piLegalGuardianshipView]: 'Seguro Privado - Tutoría Legal',
  [PageView.piRescueView]: 'Seguro Privado - Rescates',
  [PageView.liSummaryView]: 'Seguro Vitalicio - Resumen',
  [PageView.liLiquidationView]: 'Seguro Vitalicio - Liquidaciones',
  [PageView.liLegalGuardianshipView]: 'Seguro Vitalicio - Tutoría Legal',
  [PageView.liPensionCreditsView]: 'Seguro Vitalicio - Créditos Pensionados',
  [PageView.liFamilyResponsabilitiesView]: 'Seguro Vitalicio - Cargas Familiares',
  [PageView.liCompensationBoxView]: 'Seguro Vitalicio - Caja Compensación',
  [PageView.liCertificatesView]: 'Seguro Vitalicio - Certificados',
  [PageView.liRescueView]: 'Seguro Vitalicio - Rescates',
  [PageView.giSummaryView]: 'Seguro Colectivo - Resumen',
  [PageView.giDetailPlanView]: 'Seguro Colectivo - Detalles de Mi Plan',
  [PageView.giFormsView]: 'Seguro Colectivo - Formularios',
  [PageView.giRefundsView]: 'Seguro Colectivo - Reembolsos',
}
